import script from "./email-form-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./email-form-modal.vue?vue&type=script&setup=true&lang=ts"

import "./email-form-modal.vue?vue&type=style&index=0&id=db2c8e38&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db2c8e38"]])

export default __exports__